import { initFirebase } from '~/utils/firebase'
import { defineNuxtPlugin, useCookie } from '#imports'

export default defineNuxtPlugin(async () => {
  if (useCookie('logged-in').value) {
    await initFirebase()
  }
})
